import { Component, OnDestroy } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { GdlService } from '../../services/gdl-service/gdl.service';

@Component({
  selector: 'wpro-pending-edits',
  template: `
    <div class="fdx-o-grid fdx-u-color--grey--dark-1">
      <h2 id="header" class="fdx-c-heading fdx-c-heading--h2 fdx-u-align--center fdx-u-mb--7">
        {{'pendingEdits.header' | translate }}
      </h2>
      <p id="message" class="fdx-c-paragraph fdx-c-paragraph--regular fdx-u-align--center fdx-u-mb--10">
        {{'pendingEdits.message' | translate }}
      </p>
      <button id="continueBtn" (click)="onSubmit(true)" class="fdx-c-button fdx-c-button--primary fdx-c-button--responsive">
        {{'common.continue' | translate }}
      </button>
      <button id="cancelBtn" (click)="onSubmit(false)" class="fdx-c-button fdx-c-button--text fdx-c-button--responsive">
        {{'common.cancel' | translate }}
      </button>
    </div>
  `,
  styles: ['button {display: block; margin: 0 auto}'],
  standalone: false
})
export class PendingEditsComponent implements OnDestroy {
  private readonly leaveWithoutSaveSub = new ReplaySubject<boolean>(1);
  gdlModal = 'modal';
  gdlFormName = 'pending-edit-confirmation';
  gdlConfirm ='confirm';
  toastFlag = false;
  ngOnDestroy(): void {
    if (!this.leaveWithoutSaveSub.closed) {
      this.leaveWithoutSaveSub.complete();
      this.leaveWithoutSaveSub.unsubscribe();
      if (this.toastFlag) {
        this.gdlService.triggerGdlLogEvent(this.gdlModal, this.gdlConfirm, { name: this.gdlFormName, choice: this.gdlConfirm });
      } else {
        this.gdlService.triggerGdlLogEvent(this.gdlModal, 'dismiss', { name: this.gdlFormName });
      }
    }
  }
  constructor(public gdlService: GdlService) { }
  leaveWithoutSave$(): Observable<boolean> {
    return this.leaveWithoutSaveSub.asObservable();
  }

  onSubmit(answer: boolean): void {
    this.toastFlag = answer;
    this.leaveWithoutSaveSub.next(answer);
  }
}
